/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DamageCase } from '../models';
/**
 * StatisticsApi - axios parameter creator
 * @export
 */
export const StatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesStatisticsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/damagecases/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics of company
         * @param {Array<DamageCase>} years the years for the statistics
         * @param {string} theme the requestet statistics
         * @param {number} [companyId] The id of the company to retrieve
         * @param {string} [damageCaseType] The type of the damagecase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsGet: async (years: Array<DamageCase>, theme: string, companyId?: number, damageCaseType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'years' is not null or undefined
            assertParamExists('statisticsGet', 'years', years)
            // verify required parameter 'theme' is not null or undefined
            assertParamExists('statisticsGet', 'theme', theme)
            const localVarPath = `/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (years) {
                localVarQueryParameter['years[]'] = years;
            }

            if (theme !== undefined) {
                localVarQueryParameter['theme'] = theme;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (damageCaseType !== undefined) {
                localVarQueryParameter['damage_case_type'] = damageCaseType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsApi - functional programming interface
 * @export
 */
export const StatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damagecasesStatisticsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DamageCase>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damagecasesStatisticsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get statistics of company
         * @param {Array<DamageCase>} years the years for the statistics
         * @param {string} theme the requestet statistics
         * @param {number} [companyId] The id of the company to retrieve
         * @param {string} [damageCaseType] The type of the damagecase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsGet(years: Array<DamageCase>, theme: string, companyId?: number, damageCaseType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DamageCase>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsGet(years, theme, companyId, damageCaseType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatisticsApi - factory interface
 * @export
 */
export const StatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsApiFp(configuration)
    return {
        /**
         * Get statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damagecasesStatisticsGet(options?: any): AxiosPromise<Array<DamageCase>> {
            return localVarFp.damagecasesStatisticsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics of company
         * @param {Array<DamageCase>} years the years for the statistics
         * @param {string} theme the requestet statistics
         * @param {number} [companyId] The id of the company to retrieve
         * @param {string} [damageCaseType] The type of the damagecase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsGet(years: Array<DamageCase>, theme: string, companyId?: number, damageCaseType?: string, options?: any): AxiosPromise<Array<DamageCase>> {
            return localVarFp.statisticsGet(years, theme, companyId, damageCaseType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticsApi - object-oriented interface
 * @export
 * @class StatisticsApi
 * @extends {BaseAPI}
 */
export class StatisticsApi extends BaseAPI {
    /**
     * Get statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public damagecasesStatisticsGet(options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).damagecasesStatisticsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics of company
     * @param {Array<DamageCase>} years the years for the statistics
     * @param {string} theme the requestet statistics
     * @param {number} [companyId] The id of the company to retrieve
     * @param {string} [damageCaseType] The type of the damagecase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsApi
     */
    public statisticsGet(years: Array<DamageCase>, theme: string, companyId?: number, damageCaseType?: string, options?: AxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).statisticsGet(years, theme, companyId, damageCaseType, options).then((request) => request(this.axios, this.basePath));
    }
}
